import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthLayout } from '../../components/layout';
import { Alert, Button, Input } from '../../components/core';
import { http } from '../../lib/api';
import { useUiStore } from '../../store/ui';

export function SignupPage() {
  const navigate = useNavigate();
  const ui = useUiStore();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    setBusy(true);
    setError(null);
    setMessage(null);
    try {
      await http.post<{ message: string }>('/api/auth/register', {
        name,
        email,
        phone,
        password,
      });
      setMessage('Account created! Check your email for the verification link, then log in.');
      ui.toast('success', 'Account created');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Registration failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Create your tenant account" subtitle="The Free plan is included — no card required.">
      {error ? <Alert kind="danger">{error}</Alert> : null}
      {message ? <Alert kind="success">{message}</Alert> : null}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          void submit();
        }}
      >
        <Input label="Studio / company name" value={name} onChange={setName} required />
        <Input label="Phone" type="tel" value={phone} onChange={setPhone} autoComplete="tel" required />
        <Input label="Email" type="email" value={email} onChange={setEmail} autoComplete="email" required />
        <Input label="Password" type="password" value={password} onChange={setPassword} autoComplete="new-password" hint="At least 8 characters" required />
        <Input label="Confirm password" type="password" value={confirmPassword} onChange={setConfirmPassword} autoComplete="new-password" required />
        <Button type="submit" disabled={busy}>{busy ? 'Creating account…' : 'Create account'}</Button>
      </form>
      <div className="mt-4 text-muted text-sm">
        Already have an account? <Link to="/login">Log in</Link>
      </div>
    </AuthLayout>
  );
}
